import { render, staticRenderFns } from "./RetailCouponEdit.vue?vue&type=template&id=92753f82&"
import script from "./RetailCouponEdit.vue?vue&type=script&lang=js&"
export * from "./RetailCouponEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports